var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 86,
    viewBox: "0 0 75 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6436 32.459L33.2678 43.88H23.6436V32.459Z",
    fill: "url(#paint0_linear_203_3109)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9699 47.199L70.82 82.059C70.6125 83.8018 69.3557 85.0971 67.8726 85.0971H8.58529C7.1022 85.0971 5.84534 83.8018 5.63786 82.059L0.0297861 34.9547C-0.223184 32.8282 1.16738 30.9282 2.97722 30.9282H21.2864C22.7695 30.9282 24.0263 32.2234 24.2338 33.9658L24.9687 40.1345C25.1762 41.8773 26.4331 43.1725 27.9162 43.1725H72.0231C73.8323 43.1725 75.2232 45.0725 74.9702 47.199H74.9699Z",
    fill: "url(#paint1_linear_203_3109)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2665 69.5481H16.1921C15.9505 69.548 15.7173 69.4433 15.536 69.2538C15.3548 69.0642 15.238 68.8028 15.2076 68.5184L14.6562 63.3375C14.6386 63.1717 14.651 63.0035 14.6925 62.8438C14.7339 62.6842 14.8035 62.5369 14.8966 62.4116C14.9897 62.2863 15.1042 62.1859 15.2325 62.1172C15.3608 62.0484 15.4999 62.0128 15.6407 62.0127H60.8179C60.9587 62.0128 61.0978 62.0484 61.2261 62.1172C61.3544 62.1859 61.4688 62.2863 61.5619 62.4116C61.6551 62.5369 61.7246 62.6842 61.7661 62.8438C61.8076 63.0035 61.8199 63.1717 61.8024 63.3375L61.251 68.5184C61.2205 68.8028 61.1038 69.0642 60.9225 69.2538C60.7413 69.4433 60.508 69.548 60.2665 69.5481Z",
    fill: "#667085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.764 15.9783L61.2786 25.5973M52.2422 5.90485L49.0476 22.2262L52.2422 5.90485ZM29.998 4.19117L36.7349 18.8326L29.998 4.19117Z",
    stroke: "#667085",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_3109",
    x1: 30.0022,
    y1: 45.7126,
    x2: 16.3973,
    y2: 34.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_203_3109",
    x1: 37.4999,
    y1: 30.9282,
    x2: 37.4999,
    y2: 85.0971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#E4E4E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFolder);
export default __webpack_public_path__ + "static/media/emptyFolder.e7927a82c40bf776ebc8e35169085798.svg";
export { ForwardRef as ReactComponent };